import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateSelectedStationOnMap = (station?: StationsState['selectedStationOnMap']) => stationsActions
  .updateSelectedStationOnMap(station);
